//@ts-nocheck
import { env } from '../appConfig'
import { setMyFilesData } from "../ActionCreator/myFiles"
import { setMyFileError} from "../ActionCreator/myFilesError"
import getApiResponse from "../Services/getApiResponseDemo";
import { v4 as uuidv4 } from "uuid";

const PAGE_SIZE = 20;

/**
 * @param {object} requestPayload
 * @param {boolean} isVirtuoso
 * @param {boolean} isGoldenTicket
 * @param {{ mode?: 'page' | 'export', onProgress?: (info: { page: number, count: number }) => void }} options
 *   - page (default): fill up to PAGE_SIZE and update Redux (browse / Prev-Next)
 *   - export: chain all nextResultKey pages; does NOT write the full set to Redux
 */
export const getMyFiles = (requestPayload, isVirtuoso = false, isGoldenTicket = false, options = {}) => {
    const mode = options?.mode === "export" ? "export" : "page";
    const onProgress = typeof options?.onProgress === "function" ? options.onProgress : null;
    const updateStore = mode !== "export";

    return async (dispatch, getState) => {

        // const tokenData = getState().initToken;
        // const token = tokenData && tokenData.token && tokenData.token.token;
        const corrId = getState().searchForm.uuid;
        const flightType = getState().searchForm.flightType;
        const isInternalUserAutheticated = getState().internalUser.isInternalUserAutheticated;
        const bookingChannel = isInternalUserAutheticated ? "internal" : "external";
        //let corrId = uuidv4();

        // Clone so pagination keys do not mutate caller's browse payload
        const payload = { ...requestPayload };
        if (mode === "export" && payload.nextResultKey) {
            delete payload.nextResultKey;
        }

        if (updateStore) {
            dispatch(setMyFileError(false))
        }

        //Axios Payload
        const config = {
            method: "POST",
            url: env.REACT_APP_API_BASE_URL + `/booking/process/getBookingDetailsV2`,
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                
                "Access-Control-Allow-Credentials": true,
                "cache-control": "no-cache",
                correlationId: corrId,
                flightType:flightType,
                bookingChannel:bookingChannel
            },
            body: JSON.stringify(payload)
        }

        if(isGoldenTicket){
            config["headers"]["channel"] = 'GOLDEN_TICKET';
        } else if(isVirtuoso){
            config["headers"]["channel"] = 'Virtuoso';
        }
        if(window.isHISUK && window.isHISUK()){
            config["headers"]["channel"] = 'HISUK';
        }

        // Convert config to requestOptions for fetch
        const requestOptions = {
            method: config.method,
            headers: config.headers,
            body: config.body
        }

        let myFilesResult = await getApiResponse(config.url, requestOptions)
        
        if (!myFilesResult) {
            if (updateStore) {
                dispatch(setMyFileError(true))
            }
            return null;
        }
         
        let resultArray = []
        if(myFilesResult?.bookings && myFilesResult?.nextResultKey){
            resultArray = myFilesResult?.bookings
            let nextMyFilesResult = myFilesResult;
            let pageCount = 1;
            if (onProgress) {
                onProgress({ page: pageCount, count: resultArray.length });
            }

            const shouldFillMore = mode === "export" || resultArray.length < PAGE_SIZE;

            if (shouldFillMore) {
                let tempResult = myFilesResult;
                let stopCounter = false;
                while (!stopCounter) {
                    if (tempResult?.nextResultKey) {
                        payload["nextResultKey"] = tempResult?.nextResultKey;
                        const nextConfig = {
                            ...config,
                            body: JSON.stringify(payload)
                        }
                        const nextRequestOptions = {
                            method: nextConfig.method,
                            headers: nextConfig.headers,
                            body: nextConfig.body
                        }
                        nextMyFilesResult = await getApiResponse(nextConfig.url, nextRequestOptions)
                        if (nextMyFilesResult && nextMyFilesResult?.bookings && nextMyFilesResult.bookings.length > 0) {
                            resultArray = [...resultArray,...nextMyFilesResult?.bookings]
                            pageCount += 1;
                            if (onProgress) {
                                onProgress({ page: pageCount, count: resultArray.length });
                            }
                            if (updateStore) {
                                dispatch(setMyFilesData(resultArray))
                                dispatch(setMyFileError(false))
                            }
                            if (mode === "page" && resultArray.length >= PAGE_SIZE) {
                                stopCounter = true;
                            } else {
                                tempResult = { ...nextMyFilesResult }
                            }
                        } else {
                            // Empty page or failed fetch — stop to avoid infinite cursor loops
                            stopCounter = true;
                        }
                    } else {
                        stopCounter = true;
                    }
                }
            }
            if (updateStore) {
                dispatch(setMyFilesData(resultArray))
                dispatch(setMyFileError(false))
            }
            nextMyFilesResult["bookings"] = resultArray
            return nextMyFilesResult
            
        }
        let data = myFilesResult?.bookings;
        if (updateStore) {
            dispatch(setMyFilesData(data))
            dispatch(setMyFileError(false))
        }
        if (onProgress && data?.length) {
            onProgress({ page: 1, count: data.length });
        }
        myFilesResult["bookings"] = data
        return myFilesResult;
        
    }
}

export const getMyFileSearchByPNR = (requestPayload) => {


    return async (dispatch, getState) => {

        // const tokenData = getState().initToken;
        // const token = tokenData && tokenData.token && tokenData.token.token;
        const corrId = getState().searchForm.uuid;
        const flightType = getState().searchForm.flightType;
        const isInternalUserAutheticated = getState().internalUser.isInternalUserAutheticated;
        const bookingChannel = isInternalUserAutheticated ? "internal" : "external";
        //let corrId = uuidv4();

        dispatch(setMyFileError(false))

        //Axios Payload
        const config = {
            method: "POST",
            url: env.REACT_APP_API_BASE_URL + `/booking/process/getBookingDetailsV2`,
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                
                "Access-Control-Allow-Credentials": true,
                "cache-control": "no-cache",
                correlationId: corrId,
                flightType:flightType ? flightType : "CAD",
                bookingChannel:bookingChannel
            },
            body: JSON.stringify(requestPayload)
        }

        if(window.isGoldenTicket && window.isGoldenTicket()){
            config["headers"]["channel"] = 'GOLDEN_TICKET';
        } else if(window.isVirtuoso && window.isVirtuoso()){
            config["headers"]["channel"] = 'Virtuoso';
        }
        if(window.isHISUK && window.isHISUK()){
            config["headers"]["channel"] = 'HISUK';
        }

        // Convert config to requestOptions for fetch
        const requestOptions = {
            method: config.method,
            headers: config.headers,
            body: config.body
        }

        let myFilesResult = await getApiResponse(config.url, requestOptions)
        
        if (!myFilesResult) {
            dispatch(setMyFileError(true))
            return null;
        }
         
        let resultArray = []
        if(myFilesResult?.bookings && myFilesResult?.nextResultKey){
            resultArray = myFilesResult?.bookings
            let nextMyFilesResult = myFilesResult;
            if (resultArray.length < PAGE_SIZE) {
                
                let tempResult = myFilesResult;
                let stopCounter = false;
                while (!stopCounter) {
                    if (tempResult?.nextResultKey) {
                        requestPayload["nextResultKey"] = tempResult?.nextResultKey;
                        const nextConfig = {
                            ...config,
                            body: JSON.stringify(requestPayload)
                        }
                        const nextRequestOptions = {
                            method: nextConfig.method,
                            headers: nextConfig.headers,
                            body: nextConfig.body
                        }
                        nextMyFilesResult = await getApiResponse(nextConfig.url, nextRequestOptions)
                        if (nextMyFilesResult && nextMyFilesResult?.bookings && nextMyFilesResult.bookings.length > 0) {
                            resultArray = [...resultArray,...nextMyFilesResult?.bookings]
                            dispatch(setMyFilesData(resultArray))
                            dispatch(setMyFileError(false))
                            if(resultArray.length >= PAGE_SIZE){
                                stopCounter = true;
                            }
                            else{
                                tempResult = { ...nextMyFilesResult }
                            }
                        } else {
                            tempResult = { ...nextMyFilesResult }
                        }
                    } else {
                        stopCounter = true;
                    }
                }
            }
            dispatch(setMyFilesData(resultArray))
            dispatch(setMyFileError(false))
            nextMyFilesResult["bookings"] = resultArray
            return nextMyFilesResult
            
        }
        let data = myFilesResult?.bookings;
        dispatch(setMyFilesData(data))
        dispatch(setMyFileError(false))
        myFilesResult["bookings"] = data
        return myFilesResult;
        
    }
}
